import styled from "styled-components"

const WelcomeBody = styled.div`
    display:flex;
    flex-direction : column;
    position:absolute;
    top : 0;
    left:0;
    right:0;
    bottom:0;
    background: ${props => {
		return props.data.primaryColor ? props.data.primaryColor : "linear-gradient(to bottom, #47548f, #28305a);"
	}};
    padding:30px;
    max-height:100%;
    overflow:hidden;
    overflow-y:auto;
    z-index : 20;
`
export default WelcomeBody;